<template>
    <div>
        <div class="arl-inline-alert" :class="`arl-alert-${type}`">
            <div class="arl-alert__content">
                <SvgComponent :icon="type" />
                <div class="alert-item">
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const { type = 'error' } = defineProps<{ type?: AlertType }>();
</script>

<style scoped lang="css">
@reference "~/assets/css/main.css";

.arl-inline-alert {
    @apply block rounded-md bg-white/90 px-4 py-3 shadow-lg;
}

.arl-inline-alert__content {
    @apply flex items-center gap-1;
}

.arl-inline-alert-error {
    @apply border-functional-error text-functional-error border bg-white;
}

.arl-inline-alert-success {
    @apply border-functional-success text-functional-success border;
}
</style>
